import { Alert, Button, Container, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useRouter } from '@tanstack/react-router';

interface ErrorComponentProps {
  error: Error;
}

export function ErrorComponent({ error }: ErrorComponentProps) {
  const router = useRouter();

  const handleReset = () => {
    router.navigate({ to: '/' });
  };

  return (
    <Container size="sm" style={{ marginTop: '10vh' }}>
      <Stack gap="lg">
        <Alert icon={<IconAlertTriangle size={24} />} title="Something went wrong" color="red" variant="filled">
          <Text size="sm">The application encountered an unexpected error.</Text>
        </Alert>

        <Stack gap="md">
          <Title order={2}>Error Details</Title>
          <Text size="sm" c="dimmed">
            {error?.message || 'Unknown error'}
          </Text>
          {error?.stack && (
            <Text
              size="xs"
              c="dimmed"
              style={{
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                maxHeight: '200px',
                overflow: 'auto',
                padding: '8px',
                backgroundColor: 'var(--mantine-color-dark-8)',
                borderRadius: '4px',
              }}
            >
              {error.stack}
            </Text>
          )}
        </Stack>

        <Button onClick={handleReset} size="lg">
          Return to Home
        </Button>
      </Stack>
    </Container>
  );
}
